// export const API_BASE_URL = "https://stagingapi.tcfglobal.org/";
import React from "react";
import { ApplePayIcon, BankIcon, CardIcon, ChequeIcon, GooglePayIcon, PayPalIcon } from "./components/Icons";

export const GTM_TOKEN = process.env.REACT_APP_GTM_ID;
export const S3_BUCKET = process.env.REACT_APP_S3_BUCKET;
export const API_BASE_URL = process.env.REACT_APP_BASE_URL;
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
export const GTM_SWITCH = process.env.REACT_APP_GTM_STATUS;
export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
export const RECAPTCHA_TOKEN = process.env.REACT_APP_RECAPTCHA_TOKEN;
export const MIXPANEL_SWITCH = process.env.REACT_APP_MIXPANEL_ACTIVE;
export const DEFAULT_BEARER_TOKEN = process.env.REACT_APP_AUTHORIZATION;

export const IUBENTA_POLICY_ID = 61218797;
export const TOKEN_KEY = "REACTAPP.TOKEN";
export const USER_KEY = "REACTAPP.USER";
export const REFRESH_TOKEN_KEY = "REACTAPP.REFRESH_TOKEN";
export const PAYMENT_INITITATED_FALG = "PAYMENT_INITIATED";

export const SUPPORTER_DESCRIPTION = [
    "Insiya read a new book every day to raise awareness and support for education.",
    "A group of friends trekked to the Everest base camp for education.",
    "Fahim participated in the Iron Man Challenge and rallied his friends to donate.",
    "Henriette gave a red thread for a euro to everyone she met"

]

export const btnName = {
    STARTFUND: 'START YOUR FUNDRAISER',
    SUPPORTFUND: 'START YOUR FUNDRAISER',
    IMAGELINK: 'THIS IS IMAGE LINK',
    TEXTLINK: 'THIS IS TEXT LINK',
    PAGENAME: 'Page Name',
    PAGETITLE: 'Title',
    PAGEVARIANT: 'Variant',
    TCFTITLE: 'The Citizens Foundation',
};

export const INACTIVE_PAGE = 0;
export const PUBLIC_PAGE = 1;
export const PRIVATE_PAGE = 2;
export const DRAFT_PAGE = 3;
export const CLOSED_PAGE = 4;
export const FLOOD_CAMPAIGN = 20;

export const PAGE_STATUS = [
    { color: "error", status: "In Active" },
    { color: "primary", status: "Public" },
    { color: "error", status: "Private" },
    { color: "error", status: "Draft" },
    { color: "error", status: "Closed" }
];

export const GENERAL_DONATION = 0;
export const ZAKAT = 1;
export const SADAQAH = 2;
export const DEFAULT_COUNTRY = {
    id: 1,
    name: 'Pakistan',
    countryId: 1
};

export const DONATION_TYPE_CONSTANTS = [
    { id: "generalDonation", name: 'General', value: GENERAL_DONATION },
    { id: "zakatDonation", name: 'Zakat', value: ZAKAT },
    { id: "sadaqahDonation", name: 'Sadaqah', value: SADAQAH },
]

export const DONATION_IMPACT_TYPES =
    { oneTime: 0, monthly: 1, annual: 2 }

export const SINGLE_OWNER_PAGE = 1;
export const TEAM_PAGE = 2;

export const keepingInTouchValues = [
    { name: "contactByEmail", label: "Yes please, I’d like to hear from you by email" },
    { name: "contactByPhone", label: "Yes please, I’d like to hear from you by phone" },
    { name: "contactBySms", label: "Yes please, I’d like to hear from you by SMS" },
    { name: "doNotContactByPost", label: "No thank you, please do not contact me by post" }
]
export const MOST_RAISED = 1;
export const LATEST = 2;
export const TRENDING = 3;

export const PAGES_SORT_BY = [
    { id: MOST_RAISED, value: "Most Raised" },
    { id: LATEST, value: "Latest" },
    { id: TRENDING, value: "Trending" }
]

export const MISSION_STATEMENT = "Every child has the right to dream and deserves a quality education. Yet, there are millions of children in Pakistan who have never seen the inside of a classroom before, learnt how to read or had a chance to fulfil their potential. Poverty is depriving them of their childhood and their dreams remain far from their reach. But together, we can change this! By stepping up to support their education, we can give them a chance to shape their future and transform their lives and communities forever. I believe in the power of education, so I’ve started this fundraising campaign to help vulnerable children in Pakistan go to school. You can help me make this happen by donating to the cause – anything that you can manage! Your contribution will go a long way in creating life-changing impact for these children. Together, let’s give more power to our children."

export const FILE_TYPES = {
    BANK_SLIP: 1
}

export const DONATIONS_LIST_TYPE = {
    HIGHEST_DONATIONS: 0,
    RECENT_DONATIONS: 1
}

export const MIN_CONTACT_LIMIT = 6
export const MAX_CONTACT_LIMIT = 14
export const MIN_NAME_LIMIT = 2
export const MAX_NAME_LIMIT = 50

export const PAYPAL = "paypal"
export const APPLE = "apple"
export const HBL = "hbl"
export const GOOGLE = "google"
export const STRIPE = "stripe"
export const CHEQUE = "cheque"
export const BANK = "bank-transfer"
export const ACH = "ach"

export const paymentOptions = [
    { id: PAYPAL, name: "PayPal", icon: <PayPalIcon width={25} height={25} />, render: false, transactionFee: 0, minDonation: 0, active: false },
    { id: ACH, name: "Bank Transfer", icon: <BankIcon width={30} height={30} />, render: false, transactionFee: 0, minDonation: 0, active: false },
    { id: APPLE, name: "Apple Pay", icon: <ApplePayIcon width={40} height={40} />, render: false, transactionFee: 0, minDonation: 0, active: false },
    { id: HBL, name: "Debit/Credit Card", icon: <CardIcon width={40} height={40} />, render: false, transactionFee: 0, minDonation: 0, active: false },
    { id: GOOGLE, name: "Google Pay", icon: <GooglePayIcon width={40} height={40} />, render: false, transactionFee: 0, minDonation: 0, active: false },
    { id: STRIPE, name: "Debit/Credit Card", icon: <CardIcon width={40} height={40} />, render: false, transactionFee: 0, minDonation: 0, active: false },
    { id: CHEQUE, name: "Cheque/Cash Pickup", icon: <ChequeIcon width={30} height={30} />, render: false, transactionFee: 0, minDonation: 0, active: false },
    { id: BANK, name: "Bank Transfer/Deposit", icon: <BankIcon width={30} height={30} />, render: false, transactionFee: 0, minDonation: 0, active: false },
]

export const FUNDRAISER_TABS = {
    BASIC_INFO: 0,
    TELL_A_STORY: 1
}

export const PROFILE_TABS = {
    DASHBOARD: 1,
    TEAM_PAGES: 2,
    USER_PAGES: 3,
    DONATION_HISTORY: 4,
    SETTINGS: 5
}


export const PAGENAME_CONSTANTS = {
    HOME: "home",
    LOGIN: "Login",
    PROFILE: "User Profile",
    PRIVACY_POLICY: "Privacy policy",
    FUNDRAISERS: "Fundraiser listing",
    FORGOT_PASSWORD: "Forgot password",
    DONATION_RECEIPT: "Donation Receipt",
    DASHBOARD: "Dashboard",
    TEAM_FUNDRAISERS: "Team fundraisers",
    PERSONAL_FUNDRAISERS: "User fundraisers",
    DONATION_HISTORY: "Donation history",
    SETTINGS: "Settings",
    FUNDRAISER: "fundraiser"
}

export const GTM_EVENTS = {
    SIGNUP_INITIATED: "signup_process_initiated",
    SIGNUP_COMPLETED: "signup_completed",
    FUNDRAISER_CREATION_INITIATED: "fundraiser_process_initiated",
    PAGE_STORY_UPDATED: "story_updated",
    PAGE_STORY_SAVED: "story_saved",
    PAGE_PUBLISHED: "story_published",
    HOME_VIEWED: "home_screen_viewed",
    LOGIN_VIEWED: "login_page_viewed",
    START_FUNDRAISER_CLICKED: "start_fundraiser_clicked",
    SUPPORT_FUNDRAISER_CLICKED: "support_fundraiser_clicked",
    BASIC_INFO_DONE: "basic_info_submitted",
    PROFILE_PAGE: "profile_page_viewed",
    DASHBOARD: "dashboard_viewed",
    TEAM_FUNDRAISERS: "team_fundraiser_viewed",
    PERSONAL_FUNDRAISERS: "personal_fundraiser_viewed",
    DONATION_HISTORY: "donation_history_viewed",
    SETTINGS: "settings_viewed",
    PROFILE_INFO_UPDATE: "profile_info_updated",
    FUNDRAISER: "fundraiser_viewed",
    DONATE_NOW_CLICKED: "donate_now_clicked",
    PAYMENT_INITIATED: "payment_initiated",
    FUNDRAISER_SHARED: "fundraiser_shared",
    PAYMENT_CONFIRMED: "paymnent_confirmed"
}
